import { getRangeValue, getTermValue } from './helpers';
import { EBalconyType, type NonEmptyArray, type TJsonQuery } from './types';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

export function getBalconyTypes(jsonQuery: TJsonQuery): NonEmptyArray<EBalconyType> | null {
  const balconies = getRangeValue('balconies')(jsonQuery);
  const loggia = getTermValue('loggia')(jsonQuery);

  const balconyTypes: EBalconyType[] = [];

  if (balconies && balconies.gte && balconies.gte > 0) {
    balconyTypes.push(EBalconyType.Balcony);
  }

  if (loggia) {
    balconyTypes.push(EBalconyType.Loggia);
  }

  return nonEmptyArrayOr(balconyTypes);
}
